/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type Recipient = { wallet: Address; amount: bigint };

export type RecipientArgs = { wallet: Address; amount: number | bigint };

export function getRecipientEncoder(): FixedSizeEncoder<RecipientArgs> {
  return getStructEncoder([
    ['wallet', getAddressEncoder()],
    ['amount', getU64Encoder()],
  ]);
}

export function getRecipientDecoder(): FixedSizeDecoder<Recipient> {
  return getStructDecoder([
    ['wallet', getAddressDecoder()],
    ['amount', getU64Decoder()],
  ]);
}

export function getRecipientCodec(): FixedSizeCodec<RecipientArgs, Recipient> {
  return combineCodec(getRecipientEncoder(), getRecipientDecoder());
}
